import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";
import useSpinWheelRewards from "./useSpinWheelRewards";
import UploadImageProof from "./UploadImageProof";
import { ImageCard } from "../../Global/ImageCard";

const SpinWheelRewards = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    spinWheelRewardsList,
    spinWheelRewardsState,
    closeImageModal,
    setSpinWheelRewardsState,
    handleUserFeedbackExcelDownload,
    updateSpinWheelTableHeadData,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useSpinWheelRewards();
  return (
    <>
      <HeadingGroup
        title="Spin Wheel Rewards"
        className={`pro-mb-4`}
      ></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: spinWheelRewardsState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={{
                    startDate: spinWheelRewardsState?.startDate
                      ? spinWheelRewardsState?.startDate
                      : null,
                    endDate: spinWheelRewardsState?.endDate
                      ? spinWheelRewardsState?.endDate
                      : null,
                    key: "selection",
                  }}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={{
            startDate: spinWheelRewardsState?.startDate
              ? spinWheelRewardsState?.startDate
              : null,
            endDate: spinWheelRewardsState?.endDate
              ? spinWheelRewardsState?.endDate
              : null,
            key: "selection",
          }}
        />
        {spinWheelRewardsList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={spinWheelRewardsList?.data?.result || []}
            uniqueID={"id"}
            fields={spinWheelRewardsState?.tableFeilds || {}}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={spinWheelRewardsState?.clearSelection}
            perpage={spinWheelRewardsState?.currentPageSize}
            assignable={true}
            deletable={false}
            editable={false}
          />
        )}

        {spinWheelRewardsList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={spinWheelRewardsState?.currentPage}
            totalPageCount={Math.ceil(
              spinWheelRewardsList?.data?.total_count /
                spinWheelRewardsState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === spinWheelRewardsState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={spinWheelRewardsState?.tableFeilds || []}
              moduleId={spinWheelRewardsList?.module_id}
              updateData={updateSpinWheelTableHeadData}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={spinWheelRewardsState.uploadImageModal}
          handleClose={handleUserFeedbackExcelDownload}
          title={`Redeem reward`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <UploadImageProof
              refetch={refetch}
              spinWheelRewardsState={spinWheelRewardsState}
              setSpinWheelRewardsState={setSpinWheelRewardsState}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={spinWheelRewardsState?.showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard
            data={spinWheelRewardsState?.imageData}
            handleClose={closeImageModal}
          />
        </ModalLayout>
      </div>
    </>
  );
};

export default SpinWheelRewards;
